import styled from 'styled-components';

import { spaceL } from '@xing-com/tokens';

export const NewsNavigation = styled.div`
  margin-bottom: calc(3 * ${spaceL});
`;
